<!--添加同住人 -->
<template>
  <div class='add-live-with-page'
       :class='{show: showPage}'>
    <topNav :title="title"></topNav>
    <div class="bcont">
      <div class="form">
        <div class="info"
             style="position:relative">
          <!-- 姓名 请填写同住人姓名（必填）-->
          <label>{{$t('addLiveWith_name')}} <i class="must">*</i></label>
          <input class="inp"
                 type="text"
                 :placeholder="$t('addLiveWith_name_place') "
                 maxlength="64"
                 v-model='bookInfo.name'>
          <i class="iconfont icon-credentials_icon"
             @click="getJingJiangToken"
             style="position: absolute;right:0.42rem;color:#999"
             v-if="isJingJiang"></i>
          <template v-else>
            <i class="iconfont icon-saoma"
               @click="sfzRe"
               v-if="sfzR && hasSfzRight"
               style="position: absolute;right:0.42rem;color:#999"></i>
          </template>
        </div>
        <div class="info">
          <!-- 手机 请填写11位手机号码（可空）-->
          <label>{{$t('book_mobile')}}</label>
          <input class="inp"
                 type="number"
                 :placeholder="$t('book_mobile_placeholder') "
                 maxlength="11"
                 v-model='bookInfo.mobile'>
        </div>
        <div class="info">
          <!-- 证件类型 请填写11位手机号码（可空）-->
          <label>{{$t('book_idCode')}} </label>
          <div class="parent">
            <gpicker ref="idCode"></gpicker>
          </div>
        </div>

        <div class="info">
          <!-- 证件号码 请填写证件号码(可空)-->
          <label>{{$t('book_idNo')}}</label>
          <input type="text"
                 class="inp"
                 :placeholder="$t('book_idNo_placeholder')"
                 v-model='bookInfo.idNo'>
        </div>

        <div class="info">
          <label>{{$t('sexDesc')}} <i class="must">*</i></label>
          <div class="parent">
            <gpicker ref="sex"
                     :placeholder="$t('memberRegister_sex_placeholder')"></gpicker>
          </div>
        </div>

        <div class="info">
          <!-- vip 没必要汉化了-->
          <label>VIP <i class="must">*</i></label>
          <div class="parent">
            <gpicker ref="vip"
                     :placeholder="$t('memberRegister_sex_placeholder')"></gpicker>
          </div>
        </div>

        <div class="info">
          <!-- 房间号-->
          <label>{{$t('book_rmno')}}<i class="must">*</i></label>
          <div class="parent">
            <input type="text"
                   class="inp"
                   v-model='bookInfo.rmno'
                   style="color:#F69C2D"
                   readonly="readonly">
          </div>
        </div>

        <div class="more"
             @click="more=!more">
          <!-- 更多参数-->
          <div class="mdiv"
               v-if="!more">{{$t('book_more_parmas')}} <i class="iconfont icon-xiaa"></i></div>
          <!-- 收起参数-->
          <div class="mdiv"
               v-else>{{$t('book_packup_parmas')}}<i class="iconfont icon-shanga"></i></div>
        </div>

        <div v-show="more">
          <div class="info long-label">
            <!--相同预定号-->
            <label>{{$t('addLiveWith_same_rsvn_no')}}</label>
            <div class="parent">
              <mt-switch v-model="bookInfo.autoRsvNo"></mt-switch>
            </div>
          </div>

          <div class="info long-label">
            <!--复制包价-->
            <label>{{$t('addLiveWith_copyPackage')}}</label>
            <div class="parent">
              <mt-switch v-model="bookInfo.autoPackages"></mt-switch>
            </div>
          </div>

          <div class="info long-label">
            <!--立即入住-->
            <label>{{$t('addLiveWith_checkIn')}}</label>
            <div class="parent">
              <mt-switch v-model="bookInfo.autoCheckIn"></mt-switch>
            </div>
          </div>

          <div class="info">
            <!--国籍-->
            <label>{{$t('addLiveWith_nation')}}</label>
            <div class="parent">
              <gpicker ref="country"></gpicker>
            </div>
          </div>

          <div class="info">
            <!--语言-->
            <label>{{$t('addLiveWith_language')}}</label>
            <div class="parent">
              <gpicker ref="language"></gpicker>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="foot l_o_btm">
      <div class="bookbtn"
           @click='book'>{{title}}
      </div>
    </div>
  </div>
</template>

<script>
  import moment from "moment";
  import popSearch from "../../common/popSearch";
  import gpicker from "../../common/gpicker";
  import multiSelect from "../../common/multiSelect";
  import {MessageBox} from "mint-ui";

  export default {
    data() {
      return {
        showPage: false, // 页面展示优化
        bookInfo: {
          masterId: '',
          name: '',
          idCode: "", //	证件类型（可空）
          idNo: "", //	证件号（可空）
          mobile: "", //	手机，散客会员时填写，协议公司可空
          rmno: "", //房号
          vip: "", //Vip
          nation: '', // 国籍

          autoRsvNo: false,
          autoPackages: false,
          autoCheckIn: true,
        },
        more: false,

        title: this.$t('addLiveWith_title'),
        sfzR: null,
        hasSfzRight: false,


        // 锦江刷身份证
        isJingJiang: localStorage.getItem('isJingJiang') == 'yes',
        jingJiangToken: '',
        chainNo: '',
        Key: '',
        secretKey: '',
      };
    },
    mounted() {
      this.bookInfo.masterId = this.$route.query.id;
      this.bookInfo.rmno = this.$route.query.rmno;
      // 是否拥有扫描身份证的权限
      this.sfzR = this.$route.query.sfzR;
      this.hasSfzRight = this.$route.query.hasSfzRight == 'yes';

      this.getSex()
      this.getLanguageAndNation()
      setTimeout(() => {
        this.showPage = true
      }, 500)
    },
    methods: {
      // 锦江读身份证
      jingjiangShuaka() {
        const self = this
        let obj = {
          'Key': this.Key,
          'Token': this.jingJiangToken,
          'Category': '1', // 1身份证 2身份证解码信息
          'EventName': 'Read',
          'CardType': 'IDCard',
          'isJingJiangLocal': true
        }
        this.wakeUpJingJiangApp('readIdCard')
        this.$http.post('/CardService/RequestForWrite', obj).then(res => {
          if (res.data.result == 0) {
            self.msg2(self.$t('jj_id_card_read_success'))
            var retVal = res.data.retVal || {}
            let so = JSON.parse(retVal.ResponseParameters || "{}") || {}
            self.bookInfo.name = so.name;
            self.bookInfo.idCode = "01";
            self.bookInfo.idNo = so.idnum;
            self.bookInfo.sex = so.sex;
          } else {
            MessageBox.alert(res.data.msg)
          }
        });
      },
      getJingJiangToken() {
        let objStr = localStorage.getItem('JingJiangSetting') || '{}'
        let obj = JSON.parse(objStr)
        this.chainNo = obj.HotelId || ''
        this.Key = obj.Key || ''
        obj.isJingJiangLocal = true
        this.$http.post('/CardService/Authorize', obj).then(res => {
          if (res.data.result == 0) {
            let retVal = res.data.retVal || {}
            this.jingJiangToken = retVal.Token || '';
            this.jingjiangShuaka()
          } else {
            this.msg2(this.$t('jj_token_error'));
          }
        });
      },

      getSex() {
        var sex = [{
          code: "1", name: this.$t('sexMale')
        }, {
          code: "2", name: this.$t('sexFemale')
        }];
        this.$refs.sex.setData(sex, '1', this.disCodeName);
      },
      getLanguageAndNation() {
        this.$http.post("/mobilepmsapi/accounting/peopleWithLanguageAndNationality")
          .then(res => {
            let data = res.data || {}
            if (data.result == 0) {
              let retVal = data.retVal || {}
              this.bookInfo.autoPackages = retVal.defaultautoPackages
              this.$refs.idCode.setData(retVal.idCode, "01", this.disCodeName); // 默认身份证
              this.$refs.vip.setData(retVal.vip, 0, this.disCodeName); // vip 默认设置一个0
              this.$refs.country.setData(retVal.country, retVal.defaultCountry, this.disCodeName);
              this.$refs.language.setData(retVal.language, retVal.defaultLanguage, this.disCodeName);
            } else {
              this.msg2(data.msg);
            }
          });
      },

      disCodeName(v) {
        return v.code + " -- " + v.name;
      },

      sfzRe() {
        var A = plus.webview.getLaunchWebview();
        var that = this;
        window.sfzback = function (a) {
          //alert(a);
          var so = JSON.parse(a);
          if (so.error_code != 0) {
            //识别失败！请正面对准身份证，当照片清楚时再拍摄。
            that.msg(this.$t("msg_error_code"));
          } else {
            that.bookInfo.name = so.name;
            that.bookInfo.idCode = "01";
            that.bookInfo.idNo = so.id_number;
            that.bookInfo.sex = so.sex;
          }
        };
        A.evalJS("getSFZ('" + that.sfzR + "')");
      },

      validForm() {
        if (_.isEmpty(this.bookInfo.name)) {
          this.msg2(this.$t("addLiveWith_no_name"));
          return false
        }
        if (!this.$refs.sex.getValue()) {
          this.msg2(this.$t("addLiveWith_no_sex"));
          return false
        }

        if (this.$refs.vip.getValue() === '') {
          this.msg2(this.$t("addLiveWith_no_vip"));
          return false
        }
        return true
      },

      //预定或者入住
      book() {
        if (this.validForm()) {
          this.bookInfo.idCode = this.$refs.idCode.getValue();
          this.bookInfo.sex = this.$refs.sex.getValue();
          this.bookInfo.nation = this.$refs.country.getValue();
          this.bookInfo.language = this.$refs.language.getValue();
          this.bookInfo.vip = this.$refs.vip.getValue();

          this.$http
            .post("/mobilepmsapi/accounting/addPeople", this.bookInfo)
            .then(res => {
              if (res.data.result == 0) {
                this.msg2(this.title + this.$t("success"));
                setTimeout(() => {
                  this.$router.go(-1);
                }, 500)
              } else {
                this.msg2(res.data.msg);
              }
            });
        }
      }
    },
    components: {
      popSearch,
      gpicker,
      multiSelect
    },
    computed: {},

    filters: {
      dateMD(value) {
        return moment(value, "YYYY-MM-DD HH:mm:ss").format("MM/DD");
      },
      fdate(value) {
        return moment(value).format("YYYY-MM-DD");
      }
    }
  };
</script>

<style lang="less">
  .add-live-with-page {
    background: #fff;
    opacity: 0;

    &.show {
      opacity: 1;
    }

    .bcont {
      padding-bottom: 2rem;

      .form {
        margin: 0.5rem 0.26666667rem 1.2rem 0.26666667rem;
        overflow: hidden;

        .more {
          width: 10rem;

          .mdiv {
            font-size: 0.32rem;
            margin: 0.3rem 0.8rem;
            color: #aaa;
            float: right;
            clear: both;

            .iconfont {
              font-size: 0.28rem;
              margin-left: .1rem;
            }
          }
        }

        .info {
          box-sizing: border-box;
          margin: 0.12rem auto;
          overflow: hidden;
          line-height: 0.88rem;
          float: left;
          clear: both;

          &.long-label {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;

            > label {
              flex: 1;
              width: auto !important;
            }

            .parent {
              border: 0;
              width: auto;
              text-align: right;
              height: auto;

              .mint-switch {
                width: auto;
              }
            }
          }

          .must {
            color: red;
          }

          .mint-switch-input:checked + .mint-switch-core {
            border-color: #f69c2e;
            background-color: #f69c2e;
          }

          label {
            box-sizing: border-box;
            padding-left: 0.13333333rem;
            float: left;
            text-align: left;
            width: 2.33333333rem;
            font-size: 0.33333333rem;
          }

          .inp {
            float: right;
            width: 6.86666667rem;
            height: 0.88rem;
            border: 1px solid #e8e8e8;
            margin: 0 0.13333333rem;
            padding: 0 0.13333333rem;
            box-sizing: border-box;
            -webkit-appearance: none;
            outline: 0;
            border-radius: 2px;
          }

          .search {
            float: right;
          }

          .parent {
            position: relative;
            margin: 0 0.13333333rem;
            padding: 0 0.13333333rem;
            float: right;
            width: 6.86666667rem;
            box-sizing: border-box;
            height: 0.88rem;
            background: #fff;
            border: 1px solid #e8e8e8;
            border-radius: 2px;

            input {
              border: none;
              width: 100%;
              height: 0.82rem;
              box-sizing: border-box;
              color: transparent;
              border-radius: 2px;
            }

            .iconfont {
              position: absolute;
              right: 0.26666667rem;
              top: 0px;
              /* transform: rotate(-90deg);*/
            }
          }

          .remark {
            width: 6.86666667rem;
            height: 1.6rem;
            border: 1px solid #e8e8e8;
            outline: none;
            box-sizing: border-box;
            display: block;
            float: right;
            padding: 7px;
            margin-left: 0.13333333rem;
            -webkit-appearance: none;
          }
        }

        p.tip {
          float: left;
          width: 100%;
          color: #a6a6a6;
          margin: 0 0 0 2.53333333rem;
        }
      }
    }

    .foot {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 1.2rem;
      background-image: -webkit-linear-gradient(to left, #ff6e61, #f6a12a);
      background-image: -o-linear-gradient(to left, #ff6e61, #f6a12a);
      background-image: linear-gradient(to left, #ff6e61, #f6a12a);
      font-size: 0.42666667rem;
      color: #fff;
      text-align: center;
      z-index: 1000;

      .bookbtn {
        line-height: 1.2rem;
        height: 1.2rem;
        box-sizing: border-box;
        width: 100%;
      }
    }

    .date-picker .input-wrapper {
      width: 100%;
      height: 0.88rem;
      border: 0;
      text-align: left;
    }
  }
</style>



// WEBPACK FOOTER //
// addLiveWith.vue?6e6e5058